module.exports = __webpack_public_path__ + "static/waterbottles-9ecc76b829bfc21cdbfe450089f72aa3.jpg";